export default __webpack_public_path__ + "search-overview-header-960-8fad8bdb4922c7ac04e1fba9d44b5210.webp";